module.exports = __webpack_public_path__ + "static/media/admin.7b811de9.svg";